// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2036":"1963674d9d1f114c1528","2415":"71bc6ff78213152d4788","6286":"a961f30f13e16c0d1a5a","8951":"5d32f64061eb442d2c4a"}[chunkId] + ".css";
};